var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135.6 116.4",
    style: {
      enableBackground: "new 0 0 135.6 116.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000104698317694431548010000008032984995133994391_);}\n\t.st1{fill:#CF896D;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 2,
    y: 2.2,
    width: 132,
    height: 112
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017495122552343572730000009790910745191671445_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000017495122552343572730000009790910745191671445_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.9,71.5H99.4c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1h32.5c1.2,0,2.1,0.9,2.1,2.1 C134,70.5,133.1,71.5,131.9,71.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.6,71.5H4.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1h32.5c1.2,0,2.1,0.9,2.1,2.1 C38.7,70.5,37.8,71.5,36.6,71.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.9,87.1H4.1C2.9,87.1,2,86.2,2,85c0-1.2,0.9-2.1,2.1-2.1h127.7c1.2,0,2.1,0.9,2.1,2.1 C134,86.2,133,87.1,131.9,87.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.3,99.6c0,1.3-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4S29.3,98.3,29.3,99.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.8,99.6c0,1.3-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4S60.8,98.3,60.8,99.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.3,99.6c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4 C86.2,97.2,87.3,98.3,87.3,99.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.3,99.6c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4 C113.2,97.2,114.3,98.3,114.3,99.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.5,111.8c0,1.3-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4S43.5,110.5,43.5,111.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.6,111.8c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4 C72.5,109.4,73.6,110.5,73.6,111.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.3,111.8c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4 C100.2,109.4,101.3,110.5,101.3,111.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.7,19.4c0.3,35.9,8,45.6,26.1,53.8C87.2,65,95.6,56.6,95.9,19.4c-10.6-0.6-19.3-4.5-26.1-11.9 C62.9,15.2,55.3,18.6,43.7,19.4 M69.8,77.6c-0.3,0-0.6-0.1-0.9-0.2c-20.4-9-29.5-19.8-29.5-60.1c0-1.1,0.9-2.1,2-2.1 C54,14.8,61.2,11.5,68.2,3c0.4-0.5,1-0.8,1.6-0.8c0.6,0,1.2,0.3,1.6,0.8c6.7,8.2,15.4,12.2,26.6,12.3c1.2,0,2.1,0.9,2.1,2.1 c0,39.9-9.1,50.8-29.5,60.1C70.4,77.6,70.1,77.7,69.8,77.6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.4,54.2c-0.8,0-1.5-0.7-1.5-1.5V27c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v25.7 C70.8,53.6,70.2,54.2,69.4,54.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.9,42.3c1.4,1.8,2,3.9,2.3,5.7c1.3-1.4,3.1-2.7,5.2-3.4c-1.4-1.8-2-3.9-2.3-5.7 C21.8,40.3,20,41.6,17.9,42.3z M18.6,54.4c-0.2,0-0.3,0-0.5-0.1c-0.8-0.2-1.2-1-1.1-1.8c0-0.1,1.1-7.7-3.9-10.1 c-0.7-0.4-1.1-1.2-0.8-1.9c0.3-0.8,1-1.2,1.8-1.1c5.6,0.9,9-6,9.1-6c0.4-0.7,1.2-1.1,1.9-0.8c0.8,0.2,1.2,1,1.1,1.8 c0,0.1-1.1,7.7,3.9,10.1c0.7,0.4,1.1,1.2,0.8,1.9c-0.3,0.8-1,1.2-1.8,1.1c-5.5-0.9-9,6-9.1,6C19.8,54.1,19.2,54.4,18.6,54.4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.2,27c2.8,1.2,4.8,3.4,6.1,5.5c0.7-2.4,1.9-5.1,4.1-7.1c-2.8-1.2-4.8-3.4-6.1-5.5 C114.7,22.4,113.4,25,111.2,27z M118.1,39.4c-0.7,0-1.3-0.4-1.5-1.1c0-0.1-2.9-8.9-9.8-8.9c-0.8,0-1.5-0.6-1.6-1.4 c-0.1-0.8,0.3-1.5,1.1-1.8c6.6-2.1,6.6-11.4,6.6-11.5c0-0.8,0.6-1.5,1.4-1.6s1.5,0.3,1.8,1.1c0,0.1,2.9,8.9,9.8,8.9 c0.8,0,1.5,0.6,1.6,1.4c0.1,0.8-0.3,1.5-1.1,1.8c-6.6,2.1-6.6,11.4-6.6,11.5c0,0.8-0.6,1.5-1.4,1.6 C118.3,39.4,118.2,39.4,118.1,39.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.8bcdd8ea5c48dcd920a6f9f2abf80ea0.svg";
export { ForwardRef as ReactComponent };